import { writeShortUrlParams } from '@intelligence/services/common';
import { isNotEmpty } from '@intelligence/v3/utils/common';
import { replaceCurrentSearchParams } from '@intelligence/v3/utils/urlSearchParams';
import { getManagedFilterUrlKeys } from '../utils/managedUrlKeys';

import type { IFilterValues } from '@intelligence/v3/filterCore/types';
import type { IFilterSyncContext, IFilterSyncTarget } from '../types';

const LEGACY_URL_FILTER_KEYS = [
  'filters_key',
  'use_url_filter',
  'granularity',
  'startDate',
  'endDate',
  'order_source',
  'order_metric',
  'order_mode',
  'order',
  'source',
  'region',
  'platform',
  'company',
  'product_model',
  'appmagic_themes',
  'appmagic_features',
  'appmagic_ip',
  'appmagic_settings',
  'appmagic_art_styles',
  'release_start_date',
  'release_end_date',
  'genre_source',
  'genre_main_genres',
  'genre_sub_genres',
  'genre_level3_genres',
  'genre_level4_genres',
  'au_range_min',
  'au_range_max',
  'revenue_range_min',
  'revenue_range_max',
  'arpu_range_min',
  'arpu_range_max',
  'downloads_range_min',
  'downloads_range_max',
];

export const syncShortLink = async (
  values: IFilterValues,
  context: IFilterSyncContext,
  shouldApply: () => boolean = () => {
    return true;
  },
): Promise<void> => {
  const res = await writeShortUrlParams({
    system_type: 'intelligence',
    params: JSON.stringify({ filter: values }),
  });
  const shortId = res?.data?.key || '';

  if (isNotEmpty(shortId) && shouldApply()) {
    const deleteQuery = Array.from(
      new Set([...LEGACY_URL_FILTER_KEYS, ...getManagedFilterUrlKeys(context?.items || [])]),
    );
    replaceCurrentSearchParams({ filter_short_id: shortId }, deleteQuery);
  }
};

export const shortLinkSyncTarget: IFilterSyncTarget = {
  name: 'shortLink',
  shouldSync: (context) => {
    return !!context.pageId;
  },
  /** 将当前 confirmed value 写成短链，并清理旧的明文筛选 URL 参数 */
  sync: (values, context) => {
    return syncShortLink(values, context, context.shouldApply);
  },
};
